import { render, staticRenderFns } from "./dg-dialog.vue?vue&type=template&id=554e917b&scoped=true"
import script from "./dg-dialog.vue?vue&type=script&lang=js"
export * from "./dg-dialog.vue?vue&type=script&lang=js"
import style0 from "./dg-dialog.vue?vue&type=style&index=0&id=554e917b&prod&scoped=true&lang=less"
import style1 from "./dg-dialog.vue?vue&type=style&index=1&id=554e917b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554e917b",
  null
  
)

export default component.exports